import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Table, Panel, PanelGroup, Form, Message, IconButton, Icon, Uploader } from 'rsuite'
import Monitoring from './Monitoring'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import * as MonitoringService from '../../../redux/actions/monitoring'
import { startLoading, doneLoading } from '../../../utils/loading'
import { cloneDeep } from 'lodash-es'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import AttachFilesForm from '../../attachfiles/AttachFilesForm'
import AttachFilesView from '../../attachfiles/AttachFilesView'
import MonitoringAttachWidget from './MonitoringAttachWidget'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import {
  getAttachments,
  saveAttachments,
  updateAttachments,
  deleteAttachments,
  getDownload,
} from '../../../redux/actions/monitoring'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import CustomNote from '../../CustomNote'

export default function ProjectTypePageView({ schema: _formSchemas, ...props }) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const dispatch = useDispatch()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_formSchemas)
  const [dataList, setDataList] = useState([])
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setDataList(formSchema.results)
  }, [formSchema])

  const handleReloadAttachments = async () => {
    startLoading()
    setIsLoading(true)
    try {
      console.log('call getAttachments.')
      const response = await getAttachments(projectId)
      let _schema = formSchema
      _schema.attachFiles = response
      setFormSchema(_schema)
      await dispatch(getSchemaSidebar(projectId))
    } catch (e) {}
    setIsLoading(false)
    onChangeIsEdit(!isEdit)
    setIsError(false)
    setIsDeleteError(false)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    doneLoading()
  }

  const handleCallService = async (id, request, monitoringId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.', request.id)
        response = await MonitoringService.updateMonitoring(id, request, request.id)

        if (response) {
          setFormSchema(response)
          await dispatch(getSchemaSidebar(projectId))
        } else {
          setIsError(true)
        }
      } else {
        console.log('call save.', request.id)
        response = await MonitoringService.saveMonitoring(id, request)
        if (response) {
          setFormSchema(response)
          await dispatch(getSchemaSidebar(projectId))
        } else {
          setIsError(true)
        }

        request.id = response.id
        response = request
      }

      onChangeIsEdit(false)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }
  const onSubmit = (data) => {
    let request = {
      projectVersionId: projectId,
      //userId: 1111,
      value: data.editorData,
      id: formSchema.id,
    }

    // setFormSchema((state) => ({
    //   ...state,
    // }))
    handleCallService(projectId, request)
    onChangeIsEdit(false)
  }

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      console.log('update')
      const response = await updateAttachments(projectId, request)

      if (response) {
        setIsEditErr(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      console.log('upload')
      const response = await saveAttachments(projectId, request)
      if (response.name) {
        setFormSchema(response)
        setIsUploadErr(false)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      console.log('call delete.')
      const status = await deleteAttachments(projectId, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getAttachments(projectId)
        setFormSchema(_schema)
        setIsDeleteError(false)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onUpload = (data) => {
    const file = data[formSchema.name]

    var formData = new FormData()
    formData.append('files', file)
    formData.set('OrderDetailListString', 'XXX')
  }

  const onUpdate = (file, newName) => {
    file['projectVersionId'] = projectId
    file['userId'] = 111
    file.label = newName

    handleUpdate(file)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.value]
    handleDelete(datas[index])
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getDownload(projectId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getDownload(projectId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const MonitoringFormEdit = (
    <Panel style={{ marginBottom: '20px' }} bodyFill>
      <Panel header="" eventKey={2} shaded>
        <Form>
          {formSchema.description && (
            <div style={{ marginBottom: 10 }}>
              <CustomAlertMessageInfo contents={formSchema.description} />
            </div>
          )}
          {/* {formSchema.descriptionNote && <CustomNote data={formSchema.descriptionNote} />}

          {formSchema.descriptionOptionals && (
            <div style={{ marginBottom: 10 }}>
              <CustomAlertMessageInfo contents={formSchema.descriptionOptionals} />
            </div>
          )} */}

          {/* <CustomIconMessageInfo content={formSchema.messageInfo} /> */}
          <CKEditorFrom
            schema={formSchema.editorData}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          <br />

          <hr />

          <MonitoringAttachWidget
            onDownload={onDownload}
            onPreview={onPreview}
            schema={formSchema.attachFiles}
          ></MonitoringAttachWidget>
        </Form>
      </Panel>
    </Panel>
  )

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        MonitoringFormEdit
      ) : (
        <div>
          {/* <Form>
            <CustomIconMessageInfo content={formSchema.messageWarning} />
          </Form> */}
          <br />
          {formSchema.id == null && <div>-ไม่ระบุ-</div>}

          <div
            style={{ wordWrap: 'break-word' }}
            dangerouslySetInnerHTML={{ __html: formSchema.editorData.value }}
          />
          <hr />
          <p> {formSchema.attachFiles.description[0]} </p>
          <AttachFilesView
            schema={formSchema.attachFiles}
            autoHeight={true}
            onDownload={onDownload}
            onPreview={onPreview}
          />
        </div>
      )}

      {showCommandButton && (
        <>
          <hr />
          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                style={{ marginRight: '10px' }}
                onClick={handleSubmit(onSubmit)}
                icon={<Icon className="bt-gost-icon-radius" icon="save" />}
              >
                บันทึกการแก้ไข
              </IconButton>

              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                onClick={handleReloadAttachments}
              >
                ยกเลิกการแก้ไข
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {'แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
